/**
 * Schemes an authored catalog link may use. `mailto:` is in the set because
 * teams really do publish a contact address as a link, and rejecting it would
 * mean deleting working links rather than fixing anything. The point of the
 * guard is to keep `javascript:` and `data:` out, since the portal renders
 * these as anchors and either would become a clickable payload
 * (input-defense).
 */
const SAFE_LINK_PROTOCOLS = new Set(['http:', 'https:', 'mailto:']);

/** True for an absolute URL in {@link SAFE_LINK_PROTOCOLS}. */
export const isSafeLinkUrl = (url: string): boolean => {
  try {
    return SAFE_LINK_PROTOCOLS.has(new URL(url).protocol);
  } catch {
    return false;
  }
};

export const buildSlackUserUrl = (id: string) =>
  `https://appfolio.slack.com/team/${id}`;
export const buildGitHubUrl = (pathQuery: string) =>
  new URL(pathQuery, 'https://github.com').toString();
